import React, { useState, useEffect } from 'react';
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser, Paging, Pager,
    Selection,
    HeaderFilter
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import CustomStore from "devextreme/data/custom_store";
import * as Utils from "../../utils/Utils";
import TreeView from 'devextreme-react/tree-view';
import DropDownBox from 'devextreme-react/drop-down-box';
import TesvikDetayIslemleri from '../tesvikdetay/TesvikDetayIslemleri';
import TesvikLoginIslemleri from "../sgklogin/TesvikLoginIslemleri";
import './TesvikIslemleri.scss'

const TesvikIslemleri = () => {


    const listeBasligi = "Teşvik İşlemleri";

    const [formYetki, setFormYetki] = useState(
        {
            sgkLogin: Utils.hasRole("tesvik|tesvikislemleri|sgkLogin"),
            onayliDonemIndir: Utils.hasRole("tesvik|tesvikislemleri|onayliDonemIndir"),
            donemIndir: Utils.hasRole("tesvik|tesvikislemleri|donemIndir"),
            tumPersonelleriSorgula: Utils.hasRole("tesvik|tesvikislemleri|tumPersonelleriSorgula"),
            tesvikKaydet: Utils.hasRole("tesvik|tesvikislemleri|tesvikKaydet"),
            tekTesvikSil: Utils.hasRole("tesvik|tesvikislemleri|tekTesvikSil"),
            tesvikDetayIslemleri: Utils.hasRole("tesvik|tesvikDetayIslemleri|listele"),
        });

    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);
    const [store, setStore] = useState(null);

    const [tesvikDetayData, setTesvikDetayData] = useState({ popupState: false, data: {} });
    const [tesvikDetayIslemData, setTesvikDetayIslemData] = useState({ popupState: false, data: {} });
    const [filterMap, setFilterMap] = useState(null);


    useEffect(() => {
        setFilterMap(Utils.getFilterMap(dataGrid));
    }, [])

    useEffect(() => {
        if (filterMap) {
            domainListYukle();
            setStore(getStore());
        }
    }, [filterMap])

    function hideTesvikIslemleriPopup() {
        setTesvikDetayData({ popupState: false, data: {} })
        yenile();
    }
    function showTesvikIslemleriPopup(data) {
        setTesvikDetayData({
            popupState: true,
            data: data
        });
    }

    function hideTesvikDetayIslemPopup() {
        setTesvikDetayIslemData({ popupState: false, data: {} })
    }
    function showTesvikDetayIslemPopup(data) {
        setTesvikDetayIslemData({
            popupState: true,
            data: {
                domainId: data.domainId,
                donemId: data.donemId,
            }
        });
    }





    const domainListYukle = () => {

        const request = new Request("/userDomain/getUserDomainList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }

    let dataGrid = null;
    let treeView = null;


    const getStore = () => {
        let tempGrid = dataGrid;
        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {
                // if (!Utils.isNotEmpty(loadOptions['take'])) {
                //     return;
                // }
                console.log("loadOptions", loadOptions);
                if (loadOptions.searchOperation == undefined) {
                    return;
                }

                let filterArr = [];
                if (treeBoxValue.length > 0) {
                    filterArr.push({
                        property: "dm.id",
                        operator: "IN",
                        value: treeBoxValue,
                        type: "Long"
                    })
                }

                let params = Utils.getGridLoadOptionsParams(loadOptions, filterMap, filterArr);

                if (tempGrid != null && tempGrid.instance != null) {
                    tempGrid.instance.clearSelection();
                }

                const request = new Request("/tesvikIslemleri/getKayitList" + encodeURI(params), "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }

    // let store = getStore();

    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                ref={(ref) => treeView = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parent.id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeView_itemSelectionChanged}
                searchMode={'contains'}
                searchEnabled={true}
            />
        );
    }

    const yenile = () => {
        setStore(getStore());
    }

    function getTesvkDetayDataInfo() {
        let tempGrid = dataGrid;


        let propData = {
            domainIdList: [],
            domainAdiList: [],
            donemIdList: [],
            donemAdiList: [],
            domainId: null,
            domainAdi: null
        }
        tempGrid.instance.getSelectedRowsData().map(sd => {
            if (propData.domainIdList.indexOf(sd.domainId) == -1) {
                propData.domainIdList.push(sd.domainId);
                propData.domainAdiList.push(sd.domain);

            }
            propData.donemIdList.push(sd.donemId);
            propData.donemAdiList.push(sd.donem);
        });

        if (propData.domainIdList.length == 0) {
            //showToast("Kayıt seçiniz", ToastType.ERROR, 1000);
            propData.success = false;
        } else if (propData.domainIdList.length > 1) {
            //showToast("Seçilen kayıtlar aynı firmaya at olması gerekir", ToastType.ERROR, 1000);
            propData.success = false;
        } else {
            propData.domainId = propData.domainIdList[0];
            propData.domainAdi = propData.domainAdiList[0];
            propData.success = true;
        }
        return propData;
    }
    function donemIndir(data) {
        let propData = getTesvkDetayDataInfo();
        if (propData.success == true) {
            propData.islem = "indir";
            showTesvikIslemleriPopup(propData);
        }
    }

    function saveTesvik(data) {
        let propData = getTesvkDetayDataInfo();
        if (propData.success == true) {
            propData.islem = "kaydet";
            showTesvikIslemleriPopup(propData);
        }
    }

    function calculateSelectedRow(options) {
        if (options.name === 'SelectedRowsSummary') {
            if (options.summaryProcess === 'start') {
                options.totalValue = 0;
            } else if (options.summaryProcess === 'calculate') {
                if (options.component.isRowSelected(options.value.ID)) {
                    options.totalValue = options.totalValue + options.value.SaleAmount;
                }
            }
        }
    }

    return (
        <React.Fragment>

            <h2 className={'dx-icon-product'} >{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    <DropDownBox
                        value={treeBoxValue}
                        valueExpr="id"
                        displayExpr="name"
                        placeholder="Firma Seçiniz..."
                        showClearButton={true}
                        dataSource={treeDataSource}
                        onValueChanged={syncTreeViewSelection}
                        contentRender={treeViewRender}
                    />
                    <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }}
                        onClick={yenile}></Button>
                </div>
            </div>

            <DataGrid
                className="tesvikListesiGrid"
                ref={ref => dataGrid = ref}
                style={{ padding: 5 }}
                width="100%"
                //height="100%"
                dataSource={store}
                key={"id"}
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={true}
                repaintChangesOnly={true}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                //selection={{mode: 'multiple', deferred:true}}
                remoteOperations={true} >
                <HeaderFilter visible={true} />
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Paging defaultPageSize={24} />
                <Pager showPageSizeSelector={true} allowedPageSizes={[12, 24, 36, 48, 60, 100, 200]} showInfo={true}  visible={true} />
                <Selection mode="multiple" selectAllMode="page" showCheckBoxesMode="onClick" />

                <Column type="buttons" caption={'İşlem'} width={70}
                    buttons={[
                        {
                            hint: 'Dönemi İndir',
                            icon: 'download',
                            visible: () => { return formYetki.sgkLogin && (formYetki.onayliDonemIndir || formYetki.donemIndir) },
                            onClick: (e) => { donemIndir(e.row.data); }
                        },
                        {
                            hint: 'Teşvik Kaydet',
                            icon: 'save',
                            visible: () => { return formYetki.sgkLogin && formYetki.tesvikKaydet },
                            onClick: (e) => { saveTesvik(e.row.data); }
                        },
                        {
                            hint: 'Teşvik Detay Listesi',
                            icon: 'search',
                            visible: () => { return formYetki.tesvikDetayIslemleri },
                            onClick: (e) => { showTesvikDetayIslemPopup(e.row.data); }
                        },
                    ]}
                />
                <Column dataField="id" width={90} caption={'Id'} dataType="string" mappingType="Long" visible={false} mappingField="t.id" />
                <Column dataField="domain" width={400} caption={'Domain'} dataType="string" visible={true} >
                    <HeaderFilter allowSearch={true} mappingField="dm.name" />
                </Column>

                <Column dataField="donem" width={90} caption={'Dönem'} dataType="string" visible={true} defaultSortOrder="desc" mappingField="dn.donem" />
                <Column dataField="personelSayi" width={70} caption="Personel Sayı" visible={true} mappingType="int" />
                <Column dataField="tesvikSayi" width={70} caption={'Teşvik Sayı'} dataType="number" visible={true} mappingType="int" />
                <Column dataField="tesvikOnaySayi" width={70} caption={'Teşvik Onay Sayı'} dataType="number" visible={true} mappingType="int" />
                <Column dataField="tesvikUyari" width={70} caption={'Teşvik Uyarı Sayı'} dataType="number" visible={true} mappingType="int" />
                

            </DataGrid>

            <Popup
                visible={tesvikDetayData.popupState}
                onHiding={hideTesvikIslemleriPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Sgk Dönem işlemleri"
                width={300}
                height={300}
            >
                <div>
                    {tesvikDetayData.popupState ? <TesvikLoginIslemleri data={tesvikDetayData.data} hide={hideTesvikIslemleriPopup} /> : null}
                </div>
            </Popup>

            <Popup
                visible={tesvikDetayIslemData.popupState}
                onHiding={hideTesvikDetayIslemPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={false}
                //title="Teşvik Detay Listesi"
                width={1200}
                height={600}
            >
                <div>
                    {tesvikDetayIslemData.popupState ? <TesvikDetayIslemleri data={tesvikDetayIslemData.data} gridClassName="tesvikDetayPopupGrid" /> : null}
                    <Button
                        width={1200}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideTesvikDetayIslemPopup}
                    />
                </div>
            </Popup>


        </React.Fragment>
    );
}

export default TesvikIslemleri;
